import { render, staticRenderFns } from "./IndexManageItem.vue?vue&type=template&id=b4796a26&scoped=true"
import script from "./IndexManageItem.vue?vue&type=script&lang=js"
export * from "./IndexManageItem.vue?vue&type=script&lang=js"
import style0 from "./IndexManageItem.vue?vue&type=style&index=0&id=b4796a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4796a26",
  null
  
)

export default component.exports